(function uiTreeExtendModuleDefinition() {
    'use strict';

    angular.module('ui.treeExtend', [])
        .directive('uiTreeNode', function() {
            return {
                require: ['uiTreeNode', '^uiTreeNodes', '^uiTree'],
                priority: -500,
                link: function (scope, element, attributes, controllers) {

                    angular.extend(controllers[0].scope, {
                        toggle: function () {
                            if (controllers[2].scope.$callbacks.toggleWrap) {
                                controllers[2].scope.$callbacks.toggleWrap();
                            } else {
                                controllers[0].scope.collapsed = !controllers[0].scope.collapsed;
                            }
                        }
                    });
                }
            };
        });
})();